import { Component, Inject, TemplateRef, ViewChild, viewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LabmoduleService } from '../../../services/labmodule.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import moment from 'moment';

@Component({
  selector: 'upload-report-dialog',
  standalone: true,
  imports: [CommonModule,
    MatIconModule
  ],
  templateUrl: './upload-report-dialog.component.html',
  styleUrl: './upload-report-dialog.component.css'
})
export class UploadReportDialogComponent {
  requisitionData: any;
  uploadedReportLIst: any;
  documentPdfURL: any;
  allfilesTouploadOK: boolean = true;
  fileconvertedtobase64: any = [];
  previewTitle = 'Requisition PDF';
  isViewingUploadedReport = false;
  isPdf = false;
  imageUrl = '';
  selectedReportForDelete: any = null;

  deleteDialogRef!: MatDialogRef<any>;
  @ViewChild('addDeleteModal') addDeleteModal!: TemplateRef<any>;


  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private dialogRef: MatDialogRef<UploadReportDialogComponent>,
    private sanitizer: DomSanitizer, private LabService: LabmoduleService, private dialog: MatDialog
  ) { }

  ngOnInit(): void {

    this.requisitionData = this.data.requisition;

    const fileUrl =
      this.requisitionData?.url
        ? this.requisitionData.url
        : this.requisitionData?.photoURL;

    if (fileUrl) {

      this.isPdf = fileUrl.toLowerCase().includes('.pdf');

      if (this.isPdf) {

        this.documentPdfURL =
          this.sanitizer.bypassSecurityTrustResourceUrl(fileUrl);
        this.previewTitle = 'Requisition PDF';

      } else {

        this.imageUrl = fileUrl;
        this.previewTitle = 'Requisition Image';
      }

      console.log("documentPdfURL", this.documentPdfURL, 'imageUrl', this.imageUrl);




    }

    this.getLabReportsByReqId();
  }
  closeDialog(): void {
    this.dialogRef.close();
  }
  deleteFile(index: number): void {

    this.fileconvertedtobase64 =
      this.fileconvertedtobase64.filter(
        (_: any, i: number) => i !== index
      );

  }
  getLabReportsByReqId() {
    var postData = {
      requisitionid: this.requisitionData.id,
    }
    this.LabService.getLabReportsByReqId(postData).subscribe((response: any) => {

      if (response) {
        console.log("get uploaded report", response)
        this.uploadedReportLIst = response.reports

      }

    })

  }
  onFileDropped($event: any) {
    this.fileBrowseHandler($event)

  }


  saveChangesLabReoprt() {
    console.log('DUMMY', this.requisitionData, this.fileconvertedtobase64);

    let lab: any = {}
    let locallabstr = localStorage.getItem("LAB_DETAILS");
    let uploadedBy = "lab"
    if (locallabstr) {
      lab = JSON.parse(locallabstr);
      uploadedBy = lab.name
    }

    if (!this.allfilesTouploadOK) {
      alert("");
      return;
    }

    if (this.fileconvertedtobase64 && this.fileconvertedtobase64.length > 0 && this.requisitionData) {

      for (var i = 0; i < this.fileconvertedtobase64.length; i++) {
        var postData = {
          data: {
            patientId: this.requisitionData.patientId,
            fileData: this.fileconvertedtobase64[i].data,
            documentType: 'Lab Report',
            fileExtension: this.fileconvertedtobase64[i].fileext,
            fileName: this.fileconvertedtobase64[i].name,
            notes: '',
            uploadedBy: uploadedBy,
            requisitionid: this.requisitionData.id,
            labid: lab.id,
            documentDate: moment().format("YYYY-MM-DD"),
            isLocked:
              this.requisitionData?.services &&
              JSON.parse(this.requisitionData.services).lockReports || 0
          }
        }


        this.LabService.LabUploadReport(postData).subscribe((response: any) => {

          if (response) {
            console.log("Report upload sucessfully")

          }
          this.closeDialog();
          //  this.getLabReportsByReqId()

        })
      }


    }

  }
  viewPdf(url: any) {
    //this.showUploadPdf =(url.name);
    window.open(url.name, '_blank');
  }
  labUplaodLable: string = "Upload"
  onClickGetReport(report: string): void {

    this.previewTitle = 'Uploaded Report';

    this.isViewingUploadedReport = true;

    this.isPdf =
      report?.toLowerCase().includes('.pdf');

    if (this.isPdf) {

      this.documentPdfURL =
        this.sanitizer.bypassSecurityTrustResourceUrl(
          report
        );

      this.imageUrl = '';

    } else {

      this.imageUrl = report;

      this.documentPdfURL = null;

    }

  }
  showRequisitionPdf(): void {

    this.previewTitle = 'Requisition PDF';

    this.isViewingUploadedReport = false;

    const fileUrl =
      this.requisitionData?.url ||
      this.requisitionData?.photoURL;

    this.isPdf =
      fileUrl?.toLowerCase().includes('.pdf');

    if (this.isPdf) {

      this.documentPdfURL =
        this.sanitizer.bypassSecurityTrustResourceUrl(
          fileUrl
        );

      this.imageUrl = '';

    } else {

      this.imageUrl = fileUrl;

      this.documentPdfURL = null;

    }

  }

  getReportFileName(fileName: string): string {

    if (!fileName) {
      return '';
    }

    return fileName.replace(
      /^[A-Za-z]+[.]?\d+\s+\d{1,2}:\d{2}:\d{2}/,
      ''
    );
  }
  openDeletePopup(report: any) {

    this.selectedReportForDelete = report;

    this.deleteDialogRef = this.dialog.open(
      this.addDeleteModal,
      {
        width: '420px',
        disableClose: true
      }
    );
  }

  closeDeleteDialog() {

    this.selectedReportForDelete = null;

    if (this.deleteDialogRef) {
      this.deleteDialogRef.close();
    }
  }
  confirmDeleteReport(): void {

    if (!this.selectedReportForDelete) {
      return;
    }

    const postData = {
      labreportid: this.selectedReportForDelete.id
    };

    this.LabService
      .deleteLabReport(postData)
      .subscribe({

        next: () => {

          this.uploadedReportLIst =
            this.uploadedReportLIst.filter(
              (x: any) =>
                x.id !== this.selectedReportForDelete.id
            );

          this.selectedReportForDelete = null;

          // this.closeDialog();
          // this.dialog.closeAll();
          if (this.deleteDialogRef) {
            this.deleteDialogRef.close();
          }
        },

        error: (err: any) => {
          console.log(err);
        }

      });

  }
  fileBrowseHandler(files: any) {

    // this.fileconvertedtobase64 = [];
    this.allfilesTouploadOK = true;
    const storedDoc = localStorage.getItem("LAB_DOCTOR");
    let doc;

    if (storedDoc) {
      doc = JSON.parse(storedDoc);
    } else {
      // Handle the case where the item does not exist
      console.warn('LAB_DOCTOR not found in localStorage.');
      doc = {}; // or set to null or an appropriate default value
    }

    var services: any = {};
    if (doc && doc.services) {
      services = JSON.parse(doc.services);
    }
    if (files && files.length > 0) {
      for (var i = 0; i < files.length; i++) {

        var reader = new FileReader();
        reader.readAsDataURL(files[i]);
        let loopfiletype = files[0].type;
        let loopfilename = files[i].name;

        if ((files[i].type == "application/pdf" || files[i].type == 'image/jpeg' || files[i].type == 'image/png')
          && files[i].size < 10 * 1024 * 1024) {
          if (services.labuploadchecklastname && !loopfilename.toLowerCase().includes(this.requisitionData.patientLastName.toLowerCase())) {
            //special case for when patine phone has to match
            alert("Patient Last Name (Surname) not found in Document file name. Please check if correct file is selected or else change file name to have Patient's Last Name (Surname) in it.");

          } else {
            reader.onload = () => {
              console.log(reader.result);
              this.fileconvertedtobase64.push({ data: reader.result, fileext: loopfiletype, name: loopfilename });
              console.log("base64 converted ", this.fileconvertedtobase64.length);
            };
          }
        } else {
          this.allfilesTouploadOK = false;
        }
      }
    }

  }
}
